
<div>
  <div id="televersement__errors" class="pb-1 pr-1 row d-none">
    <div class="d-inline-flex col">
      <div class="cercleErreur cercleErreur-televersement mr-1">
        <span class="cercleErreur-contenu">!</span>
      </div>
      <div class="d-flex">
        <ul class="pl-0 m-0 d-inline-block">
          <li id="error-filesMultiple" class="televersementInvalide d-none"></li>

          <li id="error-type" class="televersementInvalide d-none"></li>

          <li id="error-size" class="televersementInvalide d-none"></li>

          <li id="error-identical-name" class="televersementInvalide d-none"></li>
        </ul>
      </div>
    </div>
  </div>
</div>
